var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"primary","padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"primary text-center white--text",attrs:{"cols":"12"}},[_c('small',[_vm._v("Copyright © 2020 - "+_vm._s(new Date().getFullYear())+" BKPSDM Kota Bandung | MANGBAGJA v1.3."+_vm._s(_vm.version_date))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }